module.exports = __webpack_public_path__ + "img/Love_death+robots_splash.8297bce6.png";